import { render } from "./chatListComponent.vue?vue&type=template&id=3a55c99e&ts=true"
import script from "./chatListComponent.vue?vue&type=script&lang=ts"
export * from "./chatListComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__